// src/pages/maintenance/AiProgressIndicator.js
// Shared "something is happening" indicator for the Maintenance AI Addendum's long-running Claude
// calls (PM generation, chat). Pass `message` when the backend streams real progress over SSE
// (PM generation does, since routes/maintenanceRoutes.js's generate-pm emits actual stage text);
// falls back to a fake rotating `messages` array for calls that are still a single blocking
// request with no real progress to report (e.g. chat).
import React, { useState, useEffect } from 'react';

const MESSAGE_INTERVAL_MS = 2800;

export default function AiProgressIndicator({ messages, message, active }) {
  const [stage, setStage] = useState(0);
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    if (!active) { setStage(0); setElapsed(0); return; }
    const clock = setInterval(() => setElapsed(e => e + 1), 1000);
    if (message) return () => clearInterval(clock);
    const stageTimer = setInterval(() => setStage(s => (s + 1) % messages.length), MESSAGE_INTERVAL_MS);
    return () => { clearInterval(stageTimer); clearInterval(clock); };
  }, [active, message, messages?.length]);

  if (!active) return null;

  return (
    <div className="mt-2">
      <div className="progress" style={{ height: 6 }}>
        <div className="progress-bar progress-bar-striped progress-bar-animated" style={{ width: '100%' }} />
      </div>
      <div className="d-flex justify-content-between text-muted mt-1" style={{ fontSize: 12 }}>
        <span>{message || messages[stage]}</span>
        <span>{elapsed}s</span>
      </div>
    </div>
  );
}
